<template>
  <div class="my-pooq-content-body">
    <portal to="customer-search">
    <div class="cus-search-wrap">
      <div class="cus-search-top">
        <h3 class="a11y-hidden">FAQ 검색</h3>
        <div class="search-box">
          <div class="search-icon">
            <SearchIcon/>
          </div>
          <input type="text" placeholder="궁금한 점이 있다면 검색해 주세요." class="search-input"
                 ref="searchInput" enterkeyhint="go"
                 @focus.prevent="onFocusSearchInput"
                 @blur.prevent="onBlurSearchInput"
                 @keypress.enter="enter"
                 :value="searchKeyword"
                 v-on:input="searchKeyword = $event.target.value">
          <label for=""></label>
          <button class="delate-btn" v-if="searchKeyword.length" @click.prevent="clearSearchKeyword">
            <span class="a11y-hidden">검색어 삭제</span>
            <DeleteTextIcon/>
          </button>
        </div>
        <button type="button" class="reload-btn" @click.prevent="reloadPage">
          <SearchReIcon v-if="!reSearchButtonActive"/>
          <SearchReActiveIcon v-if="reSearchButtonActive"/>
        </button>
      </div>
      <div class="faq-top">
        <h3 class="faq-top-hd">자주 묻는 질문</h3>
        <ul>
          <li v-for="(recommendFaq, index) in recommendList" :key="'recommendFaq_'+index">
            <a href="#" @click.prevent="()=>clickRecommendFaq(recommendFaq)">{{recommendFaq.displaykeywords}}</a>
          </li>
        </ul>
      </div>
    </div>
    <faq-filter-list-for-device v-if="!filterIsLoading && isMobileDevice" :filtered-filter-list="filteredFilterList" :set-filter-fn="setFilter" :filter-text="filterText">
    </faq-filter-list-for-device>
    <faq-filter-list v-else-if="!filterIsLoading" :filtered-filter-list="filteredFilterList" :toggle-select-box-fn="toggleSelectBox" :set-filter-fn="setFilter"
                     :filter-text="filterText" :toggle-select="toggleSelect"
    ></faq-filter-list>
    </portal>
    <div class="customer-wrap"
         v-infinite-scroll="loadMore"
         :infinite-scroll-distance="200"
         :infinite-scroll-throttle-delay="200" >
      <my-pooq-empty-list v-if="showEmptyList" :info-text="getEmptyText()"></my-pooq-empty-list>
      <ul>
        <li v-for="(faq, index) in faqList" :key="'faq_list_'+index">
          <button type="button" class="cus-list-btn" @click.prevent="()=>openFaqDetail(faq)">
            <span class="cus-preview">
                <span class="type">{{faq.faqtypetext}}</span>
                <strong v-html="faq.faqtitle"></strong>
            </span>
            <ListPlus v-if="!faq.open"/>
            <ListMinus v-if="faq.open"/>
          </button>
          <span class="faq-list-detail" v-if="faq.open">
            <div v-html="faq.content || faq.example"></div>
          </span>
        </li>
      </ul>
    </div>
    <div class="btn-float" @click.prevent="openKaKaoBizMsg">
      <a href="#">
        <img src="@/assets/images/btn-kakao.png" alt="카카오톡 상담하기">
        <form id="form-biz" action="https://bizmessage.kakao.com/chat/open" method="post" target="_blank">
          <input type="hidden" name="uuid" value="@wavve웨이브" />
          <input type="hidden" name="extra" value="mobile"/>
        </form>
      </a>
    </div>
  </div>
</template>
<script>
import DeleteTextIcon from '@/assets/svg/common/ic-input-delete.svg'
import SearchReIcon from '@/assets/svg/common/ic-search-re-d.svg'
import SearchReActiveIcon from '@/assets/svg/common/ic-search-re-a.svg'
import SearchIcon from '@/assets/svg/common/ic-input-search.svg'

import ListPlus from '@/assets/svg/common/ic-list-plus.svg'
import ListMinus from '@/assets/svg/common/ic-list-minus.svg'
import MyPooqEmptyList from '@/components/lnb/mypooq/MyPooqEmptyList'
import { CustomerService } from '@/common/api/api.service'
import { get, replace } from 'lodash'
import { infiniteScroll } from '@/common/directives'
import { EventBus } from '@/components/eventbus/EventBus'
import { isMobileDevice } from '@/common/util/ua'
import FaqFilterList from '@/components/lnb/customer/FaqFilterList'
import FaqFilterListForDevice from '@/components/lnb/customer/FaqFilterListForDevice'
import { isApp } from '@/common/util/common'
import { disablePageScroll, enablePageScroll } from 'scroll-lock'
export default {
  name: 'CustomerFaq',
  components: {
    FaqFilterListForDevice,
    DeleteTextIcon,
    SearchReIcon,
    SearchReActiveIcon,
    SearchIcon,
    ListPlus,
    ListMinus,
    MyPooqEmptyList,
    FaqFilterList
  },
  directives: {
    infiniteScroll
  },
  data () {
    return {
      toggleSelect: false,
      recommendList: [],
      faqFilterList: [],
      filteredFilterList: [],
      faqList: [],
      offset: 0,
      limit: 20,
      filterId: 'all',
      filterText: '전체',
      faqId: '',
      searchKeyword: '',
      endOfList: false,
      showEmptyList: false,
      reSearchButtonActive: false,
      searchSelected: false,
      filterIsLoading: true,
      isLoading: false
    }
  },
  computed: {
    isMobileDevice () {
      return isMobileDevice()
    }
  },
  methods: {
    reloadPage () {
      this.searchKeyword = ''
      this.reset()
      this.setData()
    },
    getEmptyText () {
      return `'${this.searchKeyword}'에 대한 FAQ가 없습니다.`
    },
    clearSearchKeyword () {
      this.searchKeyword = ''
    },
    onFocusSearchInput () {
      if (isApp()) {
        disablePageScroll(document.getElementsByTagName('body')[0])
        document.getElementsByTagName('body')[0].classList.add('focus-on')
      }
    },
    onBlurSearchInput () {
      if (isApp()) {
        enablePageScroll(document.getElementsByTagName('body')[0])
        document.getElementsByTagName('body')[0].classList.remove('focus-on')
      }
    },
    enter () {
      this.reset()
      this.setData()
      document.querySelector('.search-input').blur()
    },
    openFaqDetail (faq) {
      if (faq.open === true) {
        faq.open = false
      } else {
        if (faq.content || faq.example) {
          faq.open = true
        } else {
          CustomerService.getFaqDetail({
            faqid: faq.faqid
          }).then(({ data }) => {
            faq.content = data.content
            faq.open = true
          })
        }
      }
    },
    reset () {
      this.faqList = []
      this.offset = 0
      this.endOfList = false
      this.showEmptyList = false
      this.reSearchButtonActive = false
    },
    toggleSelectBox () {
      this.toggleSelect = !this.toggleSelect
    },
    clickRecommendFaq (recommendFaq) {
      if ('' + this.faqList[0].faqid === recommendFaq.searchkeyword) {
        this.faqList[0].open = true
      } else {
        CustomerService.getFaqDetail({ faqid: recommendFaq.searchkeyword }).then(({ data }) => {
          data.open = false
          this.faqList = [data].concat(this.faqList.map((faq) => {
            faq.open = false
            return faq
          }))
          this.openFaqDetail(this.faqList[0])
        })
      }
      window.scrollTo(0, 0)
    },
    setFilter (filter) {
      this.reset()
      this.$nextTick(() => {
        this.filterId = filter.id
        this.filterText = filter.text
        if (isMobileDevice) {
          this.filteredFilterList = this.faqFilterList
        } else {
          this.filteredFilterList = this.faqFilterList.filter((filterItem) => {
            return filterItem.id !== this.filterId
          })
        }
        this.toggleSelectBox()
        this.setData()
      })
      window.scrollTo(0, 0)
    },
    loadMore () {
      if (this.endOfList) return

      this.setData()
    },
    setData () {
      if (this.isLoading) return
      this.isLoading = true
      let service = null
      if (this.searchKeyword !== '') {
        this.reSearchButtonActive = true
        service = CustomerService.searchFaqList({
          type: this.filterId,
          keyword: this.searchKeyword,
          offset: this.offset,
          limit: this.limit,
          orderby: this.orderby
        }).then((response) => {
          response.data.list = response.data.list.map((faq) => {
            faq.faqtitle = replace(faq.faqtitle, new RegExp(this.searchKeyword, 'g'), `<span style="color:#3887ff">${this.searchKeyword}</span>`)
            return faq
          })
          return response
        })
      } else {
        service = CustomerService.getFaqList({
          type: this.filterId,
          faqId: this.faqId,
          offset: this.offset,
          limit: this.limit,
          orderby: 'new'
        })
      }
      service.then(({ data }) => {
        let resList = get(data, 'list', []).map((faq) => {
          faq.open = false
          return faq
        })
        this.endOfList = resList.length === 0
        this.offset += this.limit
        this.showEmptyList = this.faqList.length === 0 && resList.length === 0
        this.faqList = this.faqList.concat(resList)

        if (!this.searchSelected && this.$route.query.faqid) {
          this.selectedFaq(this.$route.query.faqid)
        }
        this.isLoading = false
      })
    },
    setRecommendFaqList () {
      CustomerService.getRecommendFaqList().then(({ data }) => {
        this.recommendList = get(data, 'list', []).map((recommend) => {
          recommend.open = false
          return recommend
        })
      })
    },
    setFilterList () {
      this.filterIsLoading = true
      CustomerService.getFaqFilters({ type: 'faqcategory' }).then(({ data }) => {
        this.faqFilterList = [{ id: 'all', image: 'image', rank: '0', text: '전체' }].concat(get(data, 'faqcategory', []))
        this.filteredFilterList = this.faqFilterList.filter((filter) => {
          return filter.id !== this.filterId
        })
        this.filterIsLoading = false
      })
    },
    openKaKaoBizMsg () {
      if (isApp()) {
        location.href = 'captvpooq://webview?url=https://kakaochattalk.service.pooq.co.kr/kakaotalk_android.html&external=y'
      } else {
        document.getElementById('form-biz').submit()
      }
    },
    selectedFaq (faqid) {
      let faqIndex
      let faqData = this.faqList.filter((faq, idx) => {
        if (faq.faqid === faqid) {
          faqIndex = idx
          return faq
        }
      })

      if (faqData.length > 0) {
        let faqList = this.faqList
        this.searchSelected = true
        faqList[faqIndex] = undefined
        faqList = faqList.filter(Boolean)
        this.faqList = faqList
        this.faqList.unshift(faqData[0])
        this.openFaqDetail(faqData[0])
      } else {
        if (this.endOfList) return
        this.setData()
      }
    }
  },
  created () {
    let kakaoBiz = document.createElement('script')
    kakaoBiz.setAttribute('src', 'https://bizmessage.kakao.com/chat/includeScript')
    document.body.appendChild(kakaoBiz)
    this.setFilterList()
    this.setRecommendFaqList()
    if (get(this.$route, 'query.searchWord', '') !== '') {
      this.searchKeyword = get(this.$route, 'query.searchWord', '')
      this.setData()
    }
    if (get(this.$route, ['query', 'filterId'], '') === '') {
      this.setData()
    }
  },
  watch: {
    filterId () {
      this.$router.push({
        name: 'faq',
        query: {
          filterId: this.filterId,
          searchWord: this.searchKeyword
        }
      }).catch(() => {})
    },
    toggleSelect () {
      EventBus.$emit('toggle', this.toggleSelect)
    }
  }
}
</script>

<style scoped>
  .customer-wrap {
    position: relative;
    width: 100%;
    /*height: 100%;*/
    /*overflow-y: scroll;*/
    /*overflow-scrolling: touch;*/
    /*-webkit-overflow-scrolling: touch;*/
  }
  .dimmed {
    position: absolute;
    top: 0;
    width: 100%;
    height: auto;
    z-index: 6000;
    background:rgba(0,0,0,.5)
  }
  /* 카카오톡 상담하기 버튼 */
  .btn-float{
    width: 48px;
    position: fixed;
    bottom: 8px;
    right: 8px;
    z-index: 1001;
    padding-bottom: 0;
    padding-bottom: calc(constant(safe-area-inset-bottom));
    padding-bottom: calc(env(safe-area-inset-bottom));
  }
  .btn-float a{
    display: block;
  }
  .btn-float img{
    max-width: 100%;
  }
</style>
